// Demo data for exploring the application without authentication

export const DEMO_USER = {
  id: 'demo-user-123',
  email: 'demo@pingearn.com',
  full_name: 'Demo Explorer',
  balance: 125.54, // Updated without welcome bonus, includes $0.02 demo ping
  current_streak: 12,
  longest_streak: 18,
  total_earned: 1247.93, // Updated without welcome bonus
  referral_code: 'DEMO2024',
  avatar_url: null,
  created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
  updated_at: new Date().toISOString(),
  age: null,
  gender: 'prefer_not_to_say',
  location: null,
  device_type: null,
  referred_by: null,
  referral_lifetime_earnings: 127.50,
  referral_earnings_this_month: 23.40,
  daily_ping_count: 3,
  last_ping_received_at: new Date().toISOString(),
  last_ping_claimed_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  signup_type: 'user',
};

export const DEMO_PINGS = [
  {
    id: 'ping-1',
    user_id: DEMO_USER.id,
    campaign_id: 'campaign-1',
    status: 'delivered',
    reward_amount: 2.50,
    created_at: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    opened_at: null,
    claimed_at: null,
    campaigns: {
      brand_name: 'Nike',
      brand_logo_url: 'https://logo.clearbit.com/nike.com',
      title: 'New Air Max Collection',
      message: 'Check out our latest Air Max sneakers - Limited time 30% off!',
      image_url: null,
    }
  },
  {
    id: 'ping-2',
    user_id: DEMO_USER.id,
    campaign_id: 'campaign-2',
    status: 'delivered',
    reward_amount: 1.75,
    created_at: new Date(Date.now() - 90 * 60 * 1000).toISOString(),
    opened_at: null,
    claimed_at: null,
    campaigns: {
      brand_name: 'Starbucks',
      brand_logo_url: 'https://logo.clearbit.com/starbucks.com',
      title: 'Happy Hour Special',
      message: 'Get 50% off on all Frappuccinos between 3-5 PM today!',
      image_url: null,
    }
  },
  {
    id: 'ping-3',
    user_id: DEMO_USER.id,
    campaign_id: 'campaign-3',
    status: 'claimed',
    reward_amount: 3.00,
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    opened_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    claimed_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    campaigns: {
      brand_name: 'Amazon',
      brand_logo_url: 'https://logo.clearbit.com/amazon.com',
      title: 'Prime Day Deals',
      message: 'Exclusive Prime Day deals on electronics - Up to 70% off!',
      image_url: null,
    }
  },
  {
    id: 'ping-4',
    user_id: DEMO_USER.id,
    campaign_id: 'campaign-4',
    status: 'claimed',
    reward_amount: 2.25,
    created_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    opened_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    claimed_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    campaigns: {
      brand_name: 'Spotify',
      brand_logo_url: 'https://logo.clearbit.com/spotify.com',
      title: 'Premium Free Trial',
      message: '3 months of Premium for free - Experience ad-free music!',
      image_url: null,
    }
  },
  {
    id: 'ping-5',
    user_id: DEMO_USER.id,
    campaign_id: 'campaign-5',
    status: 'claimed',
    reward_amount: 1.50,
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    opened_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    claimed_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    campaigns: {
      brand_name: 'Uber Eats',
      brand_logo_url: 'https://logo.clearbit.com/uber.com',
      title: 'Free Delivery Weekend',
      message: 'Order your favorite food with zero delivery fees this weekend!',
      image_url: null,
    }
  },
];

export const DEMO_CAMPAIGNS = [
  {
    id: 'campaign-adv-1',
    advertiser_id: DEMO_USER.id,
    brand_name: 'Demo Brand',
    brand_logo_url: 'https://logo.clearbit.com/google.com',
    title: 'Summer Product Launch',
    message: 'Introducing our revolutionary new product line',
    image_url: null,
    cta_link: 'https://example.com',
    reward_amount: 2.50,
    total_budget: 5000,
    spent_budget: 2150.00,
    status: 'active',
    is_paused: false,
    delivered_count: 860,
    opened_count: 645,
    claimed_count: 502,
    target_age_min: 18,
    target_age_max: 45,
    target_gender: 'all',
    target_locations: ['US', 'CA', 'UK'],
    target_interests: ['technology', 'shopping'],
    target_device: ['mobile', 'tablet'],
    start_date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    end_date: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'campaign-adv-2',
    advertiser_id: DEMO_USER.id,
    brand_name: 'Demo Brand',
    brand_logo_url: 'https://logo.clearbit.com/google.com',
    title: 'Flash Sale Event',
    message: '24-hour flash sale with incredible discounts',
    image_url: null,
    cta_link: 'https://example.com/sale',
    reward_amount: 1.75,
    total_budget: 2000,
    spent_budget: 1890.00,
    status: 'active',
    is_paused: true,
    delivered_count: 1080,
    opened_count: 756,
    claimed_count: 621,
    target_age_min: 25,
    target_age_max: 55,
    target_gender: 'all',
    target_locations: ['US'],
    target_interests: ['shopping', 'deals'],
    target_device: ['mobile'],
    start_date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date().toISOString(),
  },
];

export const DEMO_ADVERTISER_BALANCE = {
  id: 'balance-1',
  advertiser_id: DEMO_USER.id,
  balance: 5850.00,
  currency: 'USD',
  created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  updated_at: new Date().toISOString(),
};

export const DEMO_TRANSACTIONS = [
  {
    id: 'tx-1',
    advertiser_id: DEMO_USER.id,
    type: 'deposit',
    amount: 10000,
    description: 'Initial deposit via Stripe',
    payment_id: 'pi_demo123',
    payment_method: 'stripe',
    status: 'completed',
    created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'tx-2',
    advertiser_id: DEMO_USER.id,
    type: 'campaign_charge',
    amount: -2150,
    description: 'Campaign charge: Summer Product Launch',
    payment_id: null,
    payment_method: null,
    status: 'completed',
    created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'tx-3',
    advertiser_id: DEMO_USER.id,
    type: 'campaign_charge',
    amount: -1890,
    description: 'Campaign charge: Flash Sale Event',
    payment_id: null,
    payment_method: null,
    status: 'completed',
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'tx-4',
    advertiser_id: DEMO_USER.id,
    type: 'refund',
    amount: 110,
    description: 'Refund from paused campaign',
    payment_id: null,
    payment_method: null,
    status: 'completed',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export const isDemoMode = () => {
  return localStorage.getItem('demoMode') === 'true';
};

export const enableDemoMode = () => {
  localStorage.setItem('demoMode', 'true');
};

export const disableDemoMode = () => {
  localStorage.removeItem('demoMode');
};

// Demo referral data
export const DEMO_REFERRALS = [
  {
    id: 'ref-1',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-1',
    referred_user_name: 'Sarah M.',
    joined_date: '2024-09-15T00:00:00Z',
    total_earned: 234.50,
    referral_earnings: 23.45,
    status: 'active',
    earnings_this_month: 45.20
  },
  {
    id: 'ref-2',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-2',
    referred_user_name: 'Mike T.',
    joined_date: '2024-10-01T00:00:00Z',
    total_earned: 189.25,
    referral_earnings: 18.93,
    status: 'active',
    earnings_this_month: 32.10
  },
  {
    id: 'ref-3',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-3',
    referred_user_name: 'Jessica L.',
    joined_date: '2024-08-20T00:00:00Z',
    total_earned: 456.80,
    referral_earnings: 45.68,
    status: 'active',
    earnings_this_month: 67.40
  },
  {
    id: 'ref-4',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-4',
    referred_user_name: 'David R.',
    joined_date: '2024-11-05T00:00:00Z',
    total_earned: 89.40,
    referral_earnings: 8.94,
    status: 'active',
    earnings_this_month: 21.30
  },
  {
    id: 'ref-5',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-5',
    referred_user_name: 'Emily C.',
    joined_date: '2024-07-12T00:00:00Z',
    total_earned: 312.75,
    referral_earnings: 31.28,
    status: 'active',
    earnings_this_month: 54.80
  },
  {
    id: 'ref-6',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-6',
    referred_user_name: 'Chris P.',
    joined_date: '2024-10-20T00:00:00Z',
    total_earned: 67.20,
    referral_earnings: 6.72,
    status: 'active',
    earnings_this_month: 15.60
  },
  {
    id: 'ref-7',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-7',
    referred_user_name: 'Amanda K.',
    joined_date: '2024-09-03T00:00:00Z',
    total_earned: 178.90,
    referral_earnings: 17.89,
    status: 'active',
    earnings_this_month: 28.70
  },
  {
    id: 'ref-8',
    referrer_id: DEMO_USER.id,
    referred_user_id: 'user-ref-8',
    referred_user_name: 'Ryan B.',
    joined_date: '2024-11-15T00:00:00Z',
    total_earned: 45.30,
    referral_earnings: 4.53,
    status: 'active',
    earnings_this_month: 12.50
  },
];
